module.exports = __webpack_public_path__ + "assets/img/report-bottom-bg2.10837cdd.png";